import { Line } from "@/_core/refactor/figures/Line";
import { Bar } from "@/_core/refactor/figures/Bar";
import { Scatter } from "@/_core/refactor/figures/Scatter";
import { Candle } from "@/_core/refactor/figures/Candle";
import { BackgroundRect } from "./figures/BackgroundRect";
import { Text } from "./texts/Text";

export const ChartFigures = {
  addScatter(params) {
    let obj = new Scatter(this.svg, this.svgAux);
    switch (params.type) {
      case "scatter":
        obj.scatter({ ...params });
        break;
      case "scatterImg":
        obj.scatterImg({ ...params });
        break;
    }
  },
  addLines(params) {
    let obj = new Line(this.svg, this.svgAux);
    switch (params.type) {
      case "line":
        obj.line({ ...params });
        break;
      case "customLine":
        obj.customLine({ ...params });
        break;
      case "linesArea":
        obj.linesArea({ ...params });
        return obj;
      case "line2Axis":
        obj.line2Axis({ ...params });
        break;
      case "multiLine":
        obj.multiLine({ ...params });
        break;
      case "lineGeneral":
        obj.lineGeneral({ ...params });
        return obj;
    }
  },
  addBars(params) {
    let obj = new Bar(this.svg, this.svgAux);
    switch (params.type) {
      case "bar":
        obj.bars({ ...params });
        if (params.hover) this.createBarHover({ ...params, ...params.hover });
        break;
      case "gBar":
        obj.barsGroup({ ...params });
        if (params.hover) this.createBarHover({ ...params, ...params.hover });
        break;
      case "hbar":
        obj.hBars({ ...params });
        break;
      case "twoStackedBars":
        obj.twoStackedBars({ ...params });
        break;
      case "multipleStackedBars":
        obj.multipleStackedBars({ ...params });
        break;
    }
  },
  addCandles(params) {
    let obj = new Candle(this.svg, this.svgAux);
    switch (params.type) {
      case "candles":
        obj.candles({ ...params });
        break;
    }
  },
  addBackgroundRect(params) {
    let obj = new BackgroundRect(this.svg, this.svgAux);
    switch (params.type) {
      case "backgroundRect":
        obj.backgroundRect({ ...params });
        break;
    }
  },
  addText(params) {
    let obj = new Text(this.svg, this.svgAux, this);
    switch (params.type) {
      case "text":
        obj.text({ ...params });
        break;
    }
  }
};
